export default () => {
  const initialData = [
    {
      name: "Philippine Digital Asset Exchange (PDAX)",
      description:
        "PDAX is the Philippine's homegrown cryptocurrency exchange that empowers Filipinos to trade cryptocurrencies backed with dedicated local support.",
      location: "Philippines (Remote) ",
      date: "April 2022 - Present",
      year: "2022",
      responsibilities: [
        "Design and Develop Microservices using NodeJs.",
        "Design and Develop SaaS.",
        "Maintain an AWS environment to make sure that all environments are running.",
        "Participate and Facilitate Scrum Events.",
      ],
    },
    {
      name: "Twist Resources Inc.",
      description:
        "A software company based in the Philippines that is associated with ToolTwist. TwistResources specialize in high-performance sites and applications optimized for the web and mobile.",
      location: "Pampanga, Philippines",
      date: "Feb 2021 - Present",
      year: "2021",
      responsibilities: [
        "Developed API with NodeJs and integrated third-party APIs.",
        "API Integrations to ReactJs Web Applications.",
        "High-level technical discussions.",
        "Participate and Facilitate Scrum Events.",
      ],
    },
    {
      name: "RMCordoviz Inc.",
      description:
        "A business consulting company based in the Las Vegas that offers services in Web Development, Game Development, Business Coaching, etc.",
      location: "Las Vegas, Nevada (Remote)",
      date: "Mar 2020 - Oct 2020",
      year: "2020",
      responsibilities: [
        "Engineered a Web Application specifically for monitoring employees' attendance and workload.",
        "Developed API using NodeJs and MongoDB.",
        "API Integrations to ReactJs Web Applications.",
        "Design and develop Email Templates.",
        "Manage Remote Server",
      ],
    },
    {
      name: "Twist Resources Inc.",
      description:
        "A software company based in the Philippines that is associated with ToolTwist. TwistResources specialize in high-performance sites and applications optimized for the web and mobile.",
      location: "Pampanga, Philippines",
      date: "Apr 2019 - Jun 2019",
      year: "2019",
      responsibilities: [
        "Design and develop a webpage with SCRUM methodology",
        "Develop back-end services (APIs) with SCRUM methodology",
        "Database Normalization.",
        "Sprint Planning for the company’s Human Resource Management webpage.",
        "Sprint Review",
      ],
    },
  ];
  return [...initialData];
};
